/** @jsx jsx */
import { jsx } from '@emotion/core';

import { styled } from '@material-ui/core/styles';
import {
  Typography,
  Card,
  CardContent,
  Box,
  Grid,
  TextField,
} from '@material-ui/core';
import EmailTextField from '../../email-text-field';
import theme from '../../../themes/theme';
import routes from '../../../routes';
import Link from '../../text-link';
import { useInvoicePaymentForgotPassword } from '../../../hooks/invoice-payment-portal/useInvoicePaymentForgotPassword';
import PGEButton from '../../buttons';

const PREFIX = 'InvoicePaymentLoginForm';

const classes = {
  card: `${PREFIX}-card`,
  cardContent: `${PREFIX}-cardContent`,
  cardActions: `${PREFIX}-cardActions`,
  hr: `${PREFIX}-hr`,
  submit: `${PREFIX}-submit`,
  paidMessageBox: `${PREFIX}-paidMessageBox`,
};

const Root = styled('div')(() => ({
  [`& .${classes.card}`]: {
    padding: '6em 6em',
    marginTop: '2em',
    [theme.breakpoints.down('sm')]: {
      padding: '4em 2em',
    },
  },
  [`& .${classes.cardContent}`]: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
  },
}));

const InvoicePaymentForgotPassword = () => {
  const {forgotPasswordForm,content,handleSubmit} = useInvoicePaymentForgotPassword();
  return (
    <Root>
      <Card className={classes.card}>
        <CardContent className={classes.cardContent}>
          <Typography variant={'h1'} css={{ marginBottom: theme.spacing(1) }}>
            {content.get('INVOICE_PAYMENT_FORGOT_PASSWORD')}
          </Typography>

          <form noValidate onSubmit={handleSubmit}>
          <Grid
              container
              justify="flex-end"
              alignContent="center"
              spacing={2}
              alignItems="center"
            >
             <Grid item xs={12}>
                <EmailTextField
                  name="email"
                  label={content.get('REGISTERED_EMAIL_ADDRESS')}
                  variant="outlined"
                  autoComplete={'email'}
                  {...forgotPasswordForm.props('email')}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  name={'pinId'}
                  label={content.get('PIN_ID')}
                  variant="outlined"
                  style={{width:'100%'}}
                  inputProps={{ minLength: 1, maxLength: 60 }}
                  {...forgotPasswordForm.props('pinId')}
                />
              </Grid>
            
            </Grid>
            <Box
              display="flex"
              justifyContent="space-between"
              css={{ marginTop: theme.spacing(3) }}
            >
              <Link
                plain
                to={routes.INVOICE_PAYMENT_PORTAL_SIGN_IN}
                variant={'body2'}
              >
                {content.get('BACK_TO_SIGNIN')}
              </Link>
              <PGEButton
                      data-testid="forgot-password-button"
                      type={'submit'}
                      variant={'contained'}
                      color={'primary'}
                      >
                      {content.get('SUBMIT')}
                    </PGEButton>
            </Box>
          </form>
        </CardContent>
      </Card>
    </Root>
  );
};

export default InvoicePaymentForgotPassword;
